var waitFor = require("../utils/waitFor");

waitFor("body.page-template-connectors", function () {
  var layoutImagesGrid = require("./layout-images-grid");

  var $loading = $("#face-loading"),
    seriesRelationshipData = false,
    layoutData = false,
    initted = false;

  function setupStickyLegend() {
    var fixedLegendTopMargin = 12;
    if ($("body.admin-bar").length > 0) fixedLegendTopMargin += 32;

    var $legend = $(".connector-face-key").css("top", fixedLegendTopMargin);
    var legendStickTop = 9999;
    var legendStickBottom = 9999;
    var isStuck = false;
    var $legendSpacer = $legend
      .clone()
      .css("visibility", "hidden")
      .hide()
      .insertAfter($legend);

    function setupScrollPoints(justBottom) {
      if (!justBottom)
        legendStickTop = $legend.offset().top - fixedLegendTopMargin;

      // prob don't need this since there's not much under it
      // legendStickBottom =
      //   $(document).height() -
      //   $(".layout-footer").outerHeight() -
      //   $(window).height();
    }

    function setSticky() {
      var scrollTop = $(window).scrollTop();
      if (
        isStuck &&
        (scrollTop < legendStickTop || scrollTop > legendStickBottom)
      ) {
        $legend.removeClass("fixed");
        $legendSpacer.hide();
        isStuck = false;
      } else if (
        !isStuck &&
        scrollTop > legendStickTop &&
        scrollTop < legendStickBottom
      ) {
        $legend.addClass("fixed");
        $legendSpacer.show();
        isStuck = true;
      }

      // console.log({
      //   scrollTop,
      //   isStuck,
      //   legendStickTop,
      //   legendStickBottom,
      // });
    }

    function updateScrollPoints(justBottom) {
      setupScrollPoints(justBottom);
      setSticky();

      setTimeout(function () {
        updateScrollPoints(true);
      }, 1000);
    }

    $(window).on("scroll.legend", setSticky);
    updateScrollPoints(false);

    $legend.css("z-index", 99);
  }

  function init() {
    if (initted !== false) return;

    $loading.show();

    // fetch faceData
    $.post(
      window.SITE_SETTINGS.ajaxurl,
      { action: "posi_get_all_layouts" },
      function (data) {
        layoutData = data;
        _initWithData();
      },
      "json"
    );

    // fetch seriesRelationshipData
    $.post(
      window.SITE_SETTINGS.ajaxurl,
      { action: "posi_get_series_relationships" },
      function (data) {
        seriesRelationshipData = data;
        _initWithData();
      },
      "json"
    );

    setTimeout(setupStickyLegend, 1000);
  }

  function _initWithData() {
    // don't continue if we don't have all the data we need
    if (seriesRelationshipData === false || layoutData === false) return;

    var categorizationData = {},
      seriesCategory = {};

    $.each(seriesRelationshipData, function (categoryName, seriesList) {
      $.each(seriesList, function (i, seriesName) {
        seriesCategory[seriesName] = categoryName;
      });
    });

    // create categorization data base on each layout's series category
    $.each(layoutData, function (i, layout) {
      var catName = seriesCategory[layout.series_name];

      categorizationData[layout.image] = catName;
    });

    initted = true;
    $loading.hide();
    layoutImagesGrid.init(layoutData, categorizationData);
  }

  if (document.location.hash == "#connector-face") init();
  else $('a[href="#connector-face"]').on("click", init);
});
